import { render, staticRenderFns } from "./NbRadioGroupLabel.vue?vue&type=template&id=723acc82&scoped=true&"
import script from "./NbRadioGroupLabel.vue?vue&type=script&lang=js&"
export * from "./NbRadioGroupLabel.vue?vue&type=script&lang=js&"
import style0 from "./NbRadioGroupLabel.vue?vue&type=style&index=0&id=723acc82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723acc82",
  null
  
)

export default component.exports